import { Card, Form, Input, Button, Typography, App as AntdApp } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useAuth } from "../stores/auth";
import { api, readErrorMessage } from "../lib/api";

export default function LoginPage() {
  const navigate = useNavigate();
  const { user, setAuth, setTokens } = useAuth();

  // Nếu đã login, redirect về trang chủ
  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);
  const { message } = AntdApp.useApp();
  const [submitting, setSubmitting] = useState(false);

  // Nếu đang redirect, không render UI
  if (user) {
    return null;
  }

  const onLogin = async (values: { username: string; password: string }) => {
    setSubmitting(true);
    try {
      const res = await api.api.auth.login.$post({ json: values });
      if (!res.ok) {
        message.error(await readErrorMessage(res));
        return;
      }
      const data = (await res.json()) as {
        user: any;
        accessToken: string;
        refreshToken: string;
        accessExpiresAt: number;
        refreshExpiresAt: number;
      };
      // Lưu tokens TRƯỚC khi gọi /me — vì /me cần Authorization header.
      setTokens({
        accessToken: data.accessToken,
        refreshToken: data.refreshToken,
        accessExpiresAt: data.accessExpiresAt,
        refreshExpiresAt: data.refreshExpiresAt,
      });
      // Fetch permissions ngay sau login
      const meRes = await api.api.auth.me.$get();
      const meData = meRes.ok
        ? ((await meRes.json()) as { permissions: any })
        : { permissions: null };
      setAuth(data.user, meData.permissions);
      navigate("/appointments");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(135deg,#2563EB 0%,#7C3AED 100%)",
        padding: 16,
      }}
    >
      <Card style={{ width: 380 }}>
        <Typography.Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
          💇 Salon Manager
        </Typography.Title>
        <Form layout="vertical" onFinish={onLogin}>
          <Form.Item
            label="Tài khoản"
            name="username"
            rules={[{ required: true, message: "Nhập tài khoản" }]}
          >
            <Input prefix={<UserOutlined />} placeholder="admin" autoFocus />
          </Form.Item>
          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[{ required: true, message: "Nhập mật khẩu" }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="••••••••" />
          </Form.Item>
          <Button block type="primary" htmlType="submit" loading={submitting}>
            Đăng nhập
          </Button>
        </Form>
      </Card>
    </div>
  );
}
